import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';

@Component({
  selector: 'app-energy-meter',
  templateUrl: './energy-meter.component.html',
  styleUrls: ['./energy-meter.component.scss']
})
export class EnergyMeterComponent implements OnInit {

  public emeterData = BaseUrlConstantsService.energyMeterApi;
  public userID: any;
  public energymeterListings: any = [];
  public dataEnergymeter: any;

  constructor(public router: Router,public service: BackendApiService) { 

    if(localStorage.getItem('role') === 'CLIENT'){
      this.userID = localStorage.getItem('user_id');
    }else if(localStorage.getItem('role') === 'ADMIN'){
      if(localStorage.getItem('admin_client_id') !== '' && localStorage.getItem('admin_client_id') !== undefined && localStorage.getItem('admin_client_id') !== null && parseInt(localStorage.getItem('admin_client_id')) > 0 ){
        this.userID = localStorage.getItem('admin_client_id');
      }
    }

  }

  ngOnInit(): void {

    this.energyMeterListing()
  }

  energyMeterListing(){
    //this.emeterData+'/energymeter-listings/"+this.userID
    // this.service.getDataWithQuery(this.emeterData+"/energymeter-listings/"+this.userID+"/0/0/0").then((sRes) => {
           
    //   let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
      
    //     if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
        
    //       let response = sensorRes.body;
          
    //       this.energymeterListings =[];

    //       if (response.result2 != undefined){

    //         if(response.result2.length != 0){

    //           this.dataEnergymeter= response.result2;

    //           if (this.dataEnergymeter.length !== 0) {

    //             let tempArr = [];
    //             let bottomLab = "";
              
    //             for (let mCount = 0; mCount < this.dataEnergymeter.length; mCount++) {

    //               let serialNumber="";
    //               let user_id = "";
    //               let name = "";
    //               let mac_address = "";

    //               serialNumber = this.dataEnergymeter[mCount].SerialNumber;
    //               user_id = this.userID;
    //               name = this.dataEnergymeter[mCount].name;
    //               mac_address = this.dataEnergymeter[mCount].mac_address;

    //               const energymeterListingsData = {
    //                 // value:value,
    //                 serialNumber: serialNumber,
    //                 UserID:  user_id,
    //                 name:  name,
    //                 mac_address:  mac_address                    
    //               };

    //               this.energymeterListings.push(energymeterListingsData);

    //             }
                

    //           }

    //         }
                
    //       }

    //     }
            
    // });
  }
  energyMeterDashboard(serialNumber){

    if(serialNumber!= undefined && serialNumber != ""){
      localStorage.setItem('serial_number', serialNumber);
    }else{
      localStorage.setItem('serial_number', '');
    }
    

    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        energyMeterId:serialNumber
      }
    }
    this.router.navigate(['energy-meter-monitoring'], navigationExtras);
  }
}
